import React from "react";

const operatorRoute = [
  //Users
  {
    key: "user-list",
    path: "/users/user-list",
    component: React.lazy(() => import("views/Operator/users/Users/UserList")),
    authority: [],
  },
  {
    key: "add-user",
    path: "/users/user-list/add-user",
    component: React.lazy(() => import("views/Operator/users/Users/AddUser")),
    authority: [],
  },
  {
    key: "edit-user",
    path: "/users/user-list/edit-user/:userId",
    component: React.lazy(() => import("views/Operator/users/Users/EditUser")),
    authority: [],
  },
  //Roles
  {
    key: "roles",
    path: "/users/roles",
    component: React.lazy(() => import("views/Operator/users/Roles/RoleList")),
    authority: [],
  },
  {
    key: "add-role",
    path: "/users/roles/add-role",
    component: React.lazy(() => import("views/Operator/users/Roles/AddRole")),
    authority: [],
  },
  {
    key: "edit-role",
    path: "/users/roles/edit-role/:roleId",
    component: React.lazy(() => import("views/Operator/users/Roles/EditRole")),
    authority: [],
  },
  //Wastes
  {
    key: "offers",
    path: "/offers",
    component: React.lazy(() => import("views/Operator/offers/OfferList")),
    authority: [],
  },
  {
    key: "add-offer",
    path: "/offers/add-offer",
    component: React.lazy(() => import("views/Operator/offers/AddOffer")),
    authority: [],
  },
  {
    key: "edit-offer",
    path: "/offers/edit-offer/:offerId",
    component: React.lazy(() => import("views/Operator/offers/EditOffer")),
    authority: [],
  },
  //Companies
  {
    key: "companies",
    path: "/companies/company-list",
    component: React.lazy(() => import("views/Operator/companies/CompanyList")),
    authority: [],
  },
  {
    key: "add-company",
    path: "/companies/company-list/add-company",
    component: React.lazy(() => import("views/Operator/companies/AddCompany")),
    authority: [],
  },
  {
    key: "edit-company",
    path: "/companies/company-list/edit-company/:companyId",
    component: React.lazy(() => import("views/Operator/companies/EditCompany")),
    authority: [],
  },
  //Charity Companies
  {
    key: "charity-companies",
    path: "/companies/charity-company-list",
    component: React.lazy(() =>
      import("views/Operator/charityCompanies/CharityCompanyList")
    ),
    authority: [],
  },
  {
    key: "add-charity-company",
    path: "/companies/charity-company-list/add-charity-company",
    component: React.lazy(() =>
      import("views/Operator/charityCompanies/AddCharityCompany")
    ),
    authority: [],
  },
  {
    key: "edit-charity-company",
    path: "/companies/charity-company-list/edit-charity-company/:charityCompanyId",
    component: React.lazy(() =>
      import("views/Operator/charityCompanies/EditCharityCompany")
    ),
    authority: [],
  },
  //Branches
  {
    key: "branches",
    path: "/companies/branches",
    component: React.lazy(() => import("views/Operator/branches/BranchList")),
    authority: [],
  },
  {
    key: "add-branch",
    path: "/companies/branches/add-branch",
    component: React.lazy(() => import("views/Operator/branches/AddBranch")),
    authority: [],
  },
  {
    key: "edit-branch",
    path: "/companies/branches/edit-branch/:branchId",
    component: React.lazy(() => import("views/Operator/branches/EditBranch")),
    authority: [],
  },
  //Tags
  {
    key: "tag-list",
    path: "/tags/tag-list",
    component: React.lazy(() => import("views/Operator/tags/TagList")),
    authority: [],
  },
  {
    key: "add-tag",
    path: "/tags/tag-list/add-tag",
    component: React.lazy(() => import("views/Operator/tags/AddTag")),
    authority: [],
  },
  {
    key: "edit-tag",
    path: "/tags/tag-list/edit-tag/:tagId",
    component: React.lazy(() => import("views/Operator/tags/EditTag")),
    authority: [],
  },
  //TagTypes
  {
    key: "tag-types",
    path: "/tags/tag-types",
    component: React.lazy(() => import("views/Operator/tagTypes/TagTypeList")),
    authority: [],
  },
  {
    key: "add-tag-type",
    path: "/tags/tag-types/add-tag-type",
    component: React.lazy(() => import("views/Operator/tagTypes/AddTagType")),
    authority: [],
  },
  {
    key: "edit-tag",
    path: "/tags/tag-types/edit-tag-type/:tagTypeId",
    component: React.lazy(() => import("views/Operator/tagTypes/EditTagType")),
    authority: [],
  },
  //Document Types
  {
    key: "document-types",
    path: "/companies/document-types",
    component: React.lazy(() =>
      import("views/Operator/documentTypes/DocumentTypeList")
    ),
    authority: [],
  },
  {
    key: "add-document-type",
    path: "/companies/document-types/add-document-type",
    component: React.lazy(() =>
      import("views/Operator/documentTypes/AddDocumentType")
    ),
    authority: [],
  },
  {
    key: "edit-document-type",
    path: "/companies/document-types/edit-document-type/:documentTypeId",
    component: React.lazy(() =>
      import("views/Operator/documentTypes/EditDocumentType")
    ),
    authority: [],
  },
  //Notifications
  {
    key: "notifications",
    path: "/notifications",
    component: React.lazy(() =>
      import("views/Operator/notifications/NotificationList")
    ),
    authority: [],
  },
  {
    key: "add-notification",
    path: "/notifications/add-notification",
    component: React.lazy(() =>
      import("views/Operator/notifications/AddNotification")
    ),
    authority: [],
  },
  {
    key: "edit-notification",
    path: "/notifications/edit-notification/:notificationId",
    component: React.lazy(() =>
      import("views/Operator/notifications/EditNotification")
    ),
    authority: [],
  },
  {
    key: "my-notifications",
    path: "/my-notifications",
    component: React.lazy(() =>
      import("views/Operator/notifications/MyNotificationList")
    ),
    authority: [],
  },
  //Referrals
  {
    key: "referral-list",
    path: "/referrals/referral-list",
    component: React.lazy(() =>
      import("views/Operator/referrals/ReferralList")
    ),
    authority: [],
  },
  {
    key: "add-referral",
    path: "/referrals/referral-list/add-referral",
    component: React.lazy(() => import("views/Operator/referrals/AddReferral")),
    authority: [],
  },
  {
    key: "edit-referral",
    path: "/referrals/referral-list/edit-referral/:referralId",
    component: React.lazy(() =>
      import("views/Operator/referrals/EditReferral")
    ),
    authority: [],
  },
  //Gift Cards
  {
    key: "gift-cards",
    path: "/gift-cards",
    component: React.lazy(() =>
      import("views/Operator/giftCards/GiftCardList")
    ),
    authority: [],
  },
  {
    key: "add-gift-card",
    path: "/gift-cards/add-gift-card",
    component: React.lazy(() => import("views/Operator/giftCards/AddGiftCard")),
    authority: [],
  },
  {
    key: "edit-gift-card",
    path: "/gift-cards/edit-gift-card/:giftCardId",
    component: React.lazy(() =>
      import("views/Operator/giftCards/EditGiftCard")
    ),
    authority: [],
  },
  //Certificates
  {
    key: "certificates",
    path: "/certificates",
    component: React.lazy(() =>
      import("views/Operator/certificates/CertificateList")
    ),
    authority: [],
  },
  {
    key: "add-certificate",
    path: "/certificates/add-certificate",
    component: React.lazy(() =>
      import("views/Operator/certificates/AddCertificate")
    ),
    authority: [],
  },
  {
    key: "edit-certificate",
    path: "/certificates/edit-certificate/:certificateID",
    component: React.lazy(() =>
      import("views/Operator/certificates/EditCertificate")
    ),
    authority: [],
  },
  //Settings
  {
    key: "setting",
    path: "/setting",
    component: React.lazy(() => import("views/Operator/setting/SettingList")),
    authority: [],
  },
  {
    key: "add-setting",
    path: "/setting/add-setting",
    component: React.lazy(() => import("views/Operator/setting/AddSetting")),
    authority: [],
  },
  {
    key: "edit-setting",
    path: "/setting/edit-setting/:settingID",
    component: React.lazy(() => import("views/Operator/setting/EditSetting")),
    authority: [],
  },
  //News
  {
    key: "news",
    path: "/website/news",
    component: React.lazy(() => import("views/Operator/news/NewsList")),
    authority: [],
  },
  {
    key: "add-news",
    path: "/website/news/add-news",
    component: React.lazy(() => import("views/Operator/news/AddNews")),
    authority: [],
  },
  {
    key: "edit-news",
    path: "/website/news/edit-news/:newsId",
    component: React.lazy(() => import("views/Operator/news/EditNews")),
    authority: [],
  },
  //Contents
  {
    key: "contents",
    path: "/website/contents",
    component: React.lazy(() => import("views/Operator/contents/ContentList")),
    authority: [],
  },
  {
    key: "add-content",
    path: "/website/contents/add-content",
    component: React.lazy(() => import("views/Operator/contents/AddContent")),
    authority: [],
  },
  {
    key: "edit-content",
    path: "/website/contents/edit-content/:contentId",
    component: React.lazy(() => import("views/Operator/contents/EditContent")),
    authority: [],
  },
  //Contracts
  {
    key: "contracts",
    path: "/website/contracts",
    component: React.lazy(() => import("views/Operator/contracts/ContractList")),
    authority: [],
  },
  {
    key: "add-contract",
    path: "/website/contracts/add-contract",
    component: React.lazy(() => import("views/Operator/contracts/AddContract")),
    authority: [],
  },
  //Stories
  {
    key: "stories",
    path: "/stories",
    component: React.lazy(() => import("views/Operator/stories/StoryList")),
    authority: [],
  },
  {
    key: "add-story",
    path: "/stories/add-story",
    component: React.lazy(() => import("views/Operator/stories/AddStory")),
    authority: [],
  },
  {
    key: "edit-story",
    path: "/stories/edit-story/:storyId",
    component: React.lazy(() => import("views/Operator/stories/EditStory")),
    authority: [],
  },
  //Operations
  {
    key: "operations",
    path: "/operations",
    component: React.lazy(() =>
      import("views/Operator/operations/OperationList")
    ),
    authority: [],
  },
  {
    key: "add-operation",
    path: "/operations/add-operation",
    component: React.lazy(() =>
      import("views/Operator/operations/AddOperation")
    ),
    authority: [],
  },
  {
    key: "edit-operation",
    path: "/operations/edit-operation/:operationId",
    component: React.lazy(() =>
      import("views/Operator/operations/EditOperation")
    ),
    authority: [],
  },
  //Permissions
  {
    key: "permissions",
    path: "/permissions",
    component: React.lazy(() =>
      import("views/Operator/permissions/PermissionList")
    ),
    authority: [],
  },
  //Car Types
  {
    key: "car-types",
    path: "/car-management/car-types",
    component: React.lazy(() => import("views/Operator/carTypes/CarTypeList")),
    authority: [],
  },
  {
    key: "add-car-type",
    path: "/car-management/car-types/add-car-type",
    component: React.lazy(() => import("views/Operator/carTypes/AddCarType")),
    authority: [],
  },
  {
    key: "edit-car-type",
    path: "/car-management/car-types/edit-car-type/:carTypeId",
    component: React.lazy(() => import("views/Operator/carTypes/EditCarType")),
    authority: [],
  },
  //Emission Types
  {
    key: "emission-types",
    path: "/car-management/emission-types",
    component: React.lazy(() =>
      import("views/Operator/emissionTypes/EmissionTypeList")
    ),
    authority: [],
  },
  {
    key: "add-emission-type",
    path: "/car-management/emission-types/add-emission-type",
    component: React.lazy(() =>
      import("views/Operator/emissionTypes/AddEmissionType")
    ),
    authority: [],
  },
  {
    key: "edit-emission-type",
    path: "/car-management/emission-types/edit-emission-type/:emissionTypeId",
    component: React.lazy(() =>
      import("views/Operator/emissionTypes/EditEmissionType")
    ),
    authority: [],
  },
  //Categories
  {
    key: "categories",
    path: "/categories/category-list",
    component: React.lazy(() =>
      import("views/Operator/categories/Categories/CategoryList")
    ),
    authority: [],
  },
  {
    key: "add-category",
    path: "/categories/category-list/add-category",
    component: React.lazy(() =>
      import("views/Operator/categories/Categories/AddCategory")
    ),
    authority: [],
  },
  {
    key: "edit-category",
    path: "/categories/category-list/edit-category/:categoryId",
    component: React.lazy(() =>
      import("views/Operator/categories/Categories/EditCategory")
    ),
    authority: [],
  },
  //Sub Categories
  {
    key: "sub-categories",
    path: "/categories/sub-categories",
    component: React.lazy(() =>
      import("views/Operator/categories/SubCategories/SubCategoryList")
    ),
    authority: [],
  },
  {
    key: "add-sub-category",
    path: "/categories/sub-categories/add-sub-category",
    component: React.lazy(() =>
      import("views/Operator/categories/SubCategories/AddSubCategory")
    ),
    authority: [],
  },
  {
    key: "edit-sub-category",
    path: "/categories/sub-categories/edit-sub-category/:subCategoryId",
    component: React.lazy(() =>
      import("views/Operator/categories/SubCategories/EditSubCategory")
    ),
    authority: [],
  },
  //Main Categories
  {
    key: "main-categories",
    path: "/categories/main-categories",
    component: React.lazy(() =>
      import("views/Operator/categories/MainCategories/MainCategoryList")
    ),
    authority: [],
  },
  {
    key: "add-main-category",
    path: "/categories/main-categories/add-main-category",
    component: React.lazy(() =>
      import("views/Operator/categories/MainCategories/AddMainCategory")
    ),
    authority: [],
  },
  {
    key: "edit-main-category",
    path: "/categories/main-categories/edit-main-category/:mainCategoryId",
    component: React.lazy(() =>
      import("views/Operator/categories/MainCategories/EditMainCategory")
    ),
    authority: [],
  },
  //Wastes
  {
    key: "waste-list",
    path: "/wastes/waste-list",
    component: React.lazy(() =>
      import("views/Operator/wastes/Wastes/WasteList")
    ),
    authority: [],
  },
  {
    key: "add-waste",
    path: "/wastes/waste-list/add-waste",
    component: React.lazy(() =>
      import("views/Operator/wastes/Wastes/AddWaste")
    ),
    authority: [],
  },
  {
    key: "edit-waste",
    path: "/wastes/waste-list/edit-waste/:wasteId",
    component: React.lazy(() =>
      import("views/Operator/wastes/Wastes/EditWaste")
    ),
    authority: [],
  },
  //Attributes
  {
    key: "attributes",
    path: "/wastes/attributes",
    component: React.lazy(() =>
      import("views/Operator/attributes/AttributeList")
    ),
    authority: [],
  },
  {
    key: "add-attribute",
    path: "/wastes/attributes/add-attribute",
    component: React.lazy(() =>
      import("views/Operator/attributes/AddAttribute")
    ),
    authority: [],
  },
  {
    key: "edit-attribute",
    path: "/wastes/attributes/edit-attribute/:attributeId",
    component: React.lazy(() =>
      import("views/Operator/attributes/EditAttribute")
    ),
    authority: [],
  },
  {
    key: "loading",
    path: "/loading",
    component: React.lazy(() => import("views/Operator/loading")),
    authority: [],
  },
  //WasteExtraTypes
  {
    key: "waste-extra-types",
    path: "/wastes/waste-extra-types",
    component: React.lazy(() =>
      import("views/Operator/wastes/WasteExtraTypes/WasteExtraTypeList")
    ),
    authority: [],
  },
  {
    key: "add-waste-extra-type",
    path: "/wastes/waste-extra-types/add-waste-extra-type",
    component: React.lazy(() =>
      import("views/Operator/wastes/WasteExtraTypes/AddWasteExtraType")
    ),
    authority: [],
  },
  {
    key: "edit-waste-extra-type",
    path: "/wastes/waste-extra-types/edit-waste-extra-type/:wasteExtraTypeId",
    component: React.lazy(() =>
      import("views/Operator/wastes/WasteExtraTypes/EditWasteExtraType")
    ),
    authority: [],
  },
  //Waste Detect
  {
    key: "waste-detect-list",
    path: "/wastes/waste-detect-list",
    component: React.lazy(() =>
      import("views/Operator/wastes/WasteDetect/WasteDetectList")
    ),
    authority: [],
  },
  {
    key: "edit-waste-detect",
    path: "/wastes/waste-detect-list/edit-waste-detect/:wasteDetectId",
    component: React.lazy(() =>
      import("views/Operator/wastes/WasteDetect/EditWasteDetect")
    ),
    authority: [],
  },
  //User Profile
  {
    key: "my-profile",
    path: "/my-profile",
    component: React.lazy(() => import("views/Operator/users/Profile")),
    authority: [],
  },
  {
    key: "my-company",
    path: "/my-company",
    component: React.lazy(() => import("views/Operator/users/Company")),
    authority: [],
  },
];

export default operatorRoute;
